import LyText from './src/index.vue'

LyText.install = function (Vue) {
    Vue.component(LyText.name, LyText)
}

export default LyText



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/text/index.js
// module id = null
// module chunks = 